import { GetDamagedCustomerAttachedImagesQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedCustomerAttachedImages/getDamagedCustomerAttachedImagesQuery.type';
import { getDamagedCustomerAttachedImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedCustomerAttachedImages/getDamagedCustomerAttachedImagesQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getDamagedCustomerAttachedImagesQueryOptions = (
  params: GetDamagedCustomerAttachedImagesQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['damagedCustomerAttachedImages', params],
    queryFn: () => getDamagedCustomerAttachedImagesFunction(params),
    enabled: true,
  });
};
